export function floatingOffsets({mobile,viewport,full=null,compactHeight=0,chatHeight=48}) {
  if(!mobile)return {back:100,chat:20};
  let back=compactHeight?compactHeight+20:100;
  let chat=compactHeight?compactHeight+12:20;
  if(full&&full.bottom>0&&full.top<viewport){
    back=full.top>=60?Math.max(100,viewport-full.top+12):100;
    const bottom=viewport-chat,top=bottom-chatHeight;
    if(bottom>full.top&&top<full.bottom)chat=Math.max(chat,viewport-full.top+12);
  }
  return {back,chat};
}
export function productFloatingVisible({mobile,product,mode,compactHeight}) {
  return !mobile||!product||(mode==='compact'&&compactHeight>0);
}

function initialize(){
  const button=document.querySelector('[data-asap-back-to-top]');
  if(!button||button.dataset.ready)return;
  button.dataset.ready='true';
  let frame=0;
  const wrapper=document.querySelector('.page-wrapper');
  const scrollHost=()=>wrapper&&getComputedStyle(wrapper).overflowY!=='visible'&&wrapper.scrollHeight>wrapper.clientHeight?wrapper:window;
  const setStyle=(e,key,value)=>{if(e.style.getPropertyValue(key)!==value)e.style.setProperty(key,value);};
  const chatNudges=()=>{
    const host=document.querySelector('shopify-chat'),list=[];
    function scan(root){
      if(!root)return;
      const nodes=[...root.querySelectorAll('.activator-nudge')];
      if(nodes.length){
        let style=root.getElementById('asap-floating-chat-placement');
        if(!style){style=document.createElement('style');style.id='asap-floating-chat-placement';root.appendChild(style);}
        const css=`.activator-nudge{left:auto!important;right:20px!important;bottom:var(--asap-floating-chat-bottom,20px)!important;visibility:var(--asap-floating-chat-visibility,visible)!important;pointer-events:var(--asap-floating-chat-pointer,auto)!important}
@media(max-width:749px){.activator-nudge{width:68px!important;min-width:68px!important;max-width:68px!important}.activator{box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:4px!important;width:68px!important;min-width:68px!important;max-width:68px!important;height:44px!important;min-height:44px!important;padding:0 8px!important;border-radius:22px!important;background:#e52421!important;color:#fff!important}.activator__icon{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:20px!important;height:24px!important}.activator__icon svg{display:none!important}.activator__icon::after{content:'👋';font-size:18px;line-height:24px;transform-origin:70% 70%;animation:var(--asap-floating-chat-wave,none)}.activator__label{font-size:0!important;line-height:16px!important}.activator__label::after{content:'Chat';font-size:12px;line-height:16px;font-weight:700}}
@keyframes asap-chat-wave{0%,60%,100%{transform:rotate(0)}10%{transform:rotate(14deg)}20%{transform:rotate(-8deg)}30%{transform:rotate(14deg)}40%{transform:rotate(-4deg)}50%{transform:rotate(0)}}
@media(prefers-reduced-motion:reduce){.activator__icon::after{animation:none!important}}`;
        if(style.textContent!==css)style.textContent=css;
        list.push(...nodes);
      }
      for(const element of root.querySelectorAll('*'))if(element.shadowRoot)scan(element.shadowRoot);
    }
    scan(host?.shadowRoot);
    return {host,nodes:list};
  };
  const paint=()=>{
    frame=0;
    const mobile=matchMedia('(max-width:749px)').matches;
    const full=document.querySelector('[data-scroll-mobile]'),compact=document.querySelector('[data-scroll-compact]');
    const fullRect=full&&!full.hidden?full.getBoundingClientRect():null;
    const compactHeight=compact&&!compact.hidden?compact.getBoundingClientRect().height:0;
    const chat=chatNudges();
    const height=chat.nodes[0]?.getBoundingClientRect().height||48;
    const tools=document.querySelector('[data-asap-scroll-tools]');
    const allowed=productFloatingVisible({mobile,product:!!tools,mode:tools?.dataset.mode,compactHeight});
    const offsets=floatingOffsets({mobile,viewport:innerHeight,full:fullRect,compactHeight,chatHeight:height});
    if(mobile&&tools&&allowed){offsets.back=compactHeight+20;offsets.chat=compactHeight+20;}
    setStyle(button,'--asap-back-offset',offsets.back+'px');
    const chatOpen=!!chat.host?.hasAttribute('open');
    if(chat.host){setStyle(chat.host,'--asap-floating-chat-bottom',offsets.chat+'px');setStyle(chat.host,'--asap-floating-chat-visibility',allowed&&!chatOpen?'visible':'hidden');setStyle(chat.host,'--asap-floating-chat-pointer',allowed&&!chatOpen?'auto':'none');setStyle(chat.host,'--asap-floating-chat-wave',mobile&&allowed&&!chatOpen?'asap-chat-wave 2.4s ease-in-out infinite':'none');}
    const scroller=scrollHost(),y=scroller===window?scrollY:scroller.scrollTop;
    const blocked=document.body.classList.contains('asap-scooter-member-open')||document.documentElement.hasAttribute('scroll-lock')||!!document.querySelector('dialog[open],shopify-chat[open],header-drawer details[open]');
    button.hidden=blocked||!allowed||y<=300;
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(paint);};
  button.addEventListener('click',()=>scrollHost().scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}));
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  wrapper?.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('asap:purchase-layout',schedule);
  document.addEventListener('shopify:section:load',schedule);
  const observer=new MutationObserver(schedule);
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open']});
  observer.observe(document.documentElement,{attributes:true,attributeFilter:['scroll-lock']});
  for(const name of ['shopify-chat','shopify-agent-runtime'])customElements.whenDefined(name).then(schedule);
  schedule();
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
}
